import React, { useEffect } from 'react';

import { CircularProgress } from '@mui/material';

import {
    useLabelModels,
    useModelsStatus,
} from '../../../../../../../../../state/app/filesSlice/index.hooks';
import { fetchLabelsModels } from '../../../../../../../../../state/app/filesSlice';

import { LABELS_MODEL_NOT_SELECTED } from '../../../../../../../../../constants/videoPlayerSettings';

import SelectField from '../../../../../../../../../components/SelectField';

import { useToolkitDispatch } from '../../../../../../../../../hooks';
import { useStyles } from './Themable.hooks';

interface IOwnProps {
    handleChange: any;
    selectedModel?: string;
}

export const SelectLabelsModels = ({
    handleChange,
    selectedModel,
}: IOwnProps) => {
    const models = useLabelModels();
    const classes = useStyles();
    const toolkitDispatch = useToolkitDispatch();
    const status = useModelsStatus();
    useEffect(() => {
        if (status === 'idle') {
            toolkitDispatch(fetchLabelsModels());
        }
    }, []);

    const options = [LABELS_MODEL_NOT_SELECTED, ...(models ?? [])];

    if (status === 'loading') {
        return <CircularProgress size={'50px'} sx={{ color: 'black' }} />;
    }
    return (
        <SelectField
            name="labels"
            overrideClass={classes}
            value={selectedModel || LABELS_MODEL_NOT_SELECTED}
            ids={options}
            handleChange={handleChange}
        />
    );
};
